// extracted by mini-css-extract-plugin
module.exports = {"basic_add_form_style":"BasicAddForm_basic_add_form_style__1uCeR","form_content_with_error":"BasicAddForm_form_content_with_error__2vI93"};